import { EntityService } from '@/services/EntityService';

export class RelatedPersonsService extends EntityService {
  static get entity() {
    return 'related-persons';
  }
}
